import { defineStore } from 'pinia';
import { useApi } from '@/lib/api';
import { useGlobalStore } from '@/store/global-store-base';

export const useTreatmentTypes = defineStore('treatment-types', () => {
  const api = useApi();
  const globalStoreBase = useGlobalStore({
    load: api.treatmentType_GetTreatmentTypes,
    dto: 'TreatmentTypeDto',
    create: api.treatmentType_CreateTreatmentType,
    update: api.treatmentType_UpdateTreatmentType,
    delete: api.treatmentType_DeleteTreatmentType,
    signalR: 'TreatmentTypeUpdate',
  });

  return {
    ...globalStoreBase,
  };
});
